import React, { Component } from 'react';
import PropTypes from 'prop-types';

class SimpleErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Error caught by boundary:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="error-boundary text-center p-5">
          <h2 className="text-danger mb-3">Something went wrong</h2>
          <p className="text-muted mb-4">
            An unexpected error occurred. Please try refreshing the page.
          </p>
          <button
            className="btn btn-primary"
            onClick={() => window.location.reload()}
          >
            Refresh Page
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

SimpleErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
};

export default SimpleErrorBoundary;